import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  Observable,
  Subject,
  take,
  takeUntil
} from 'rxjs'
import { selectUser } from '../../../store/auth/auth.selectors'
import { User, UserBusinesses } from '../../../store/auth/auth.state'
import { ToastrService } from 'ngx-toastr'
import { HolidayService } from '../../../services/holiday.service'
import { CommonModule, NgFor, NgIf } from '@angular/common'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { Office } from '../../../store/office/office.state'
import { selectOffices } from '../../../store/office/office.reducer'
import { loadOffices, resetOfficeState } from '../../../store/office/office.actions'
import 'select2'
import { loadBusinesses } from '../../../store/business/business.actions'
import { Business } from '../../../store/business/business.state'
import { selectAllBusinesses } from '../../../store/business/business.selectors'
import { eps } from '../../../services/url.service'
import { RouterModule } from '@angular/router'
import { NgSelectModule } from '@ng-select/ng-select'
import { UtilsService } from '../../../services/utils.service'
import { SharedModule } from '../../../shared/shared.module'
import { content } from 'html2canvas/dist/types/css/property-descriptors/content'
import { NgxDaterangepickerBootstrapDirective } from 'ngx-daterangepicker-bootstrap'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import flatpickr from 'flatpickr'
export interface Holiday {
  id: string
  title: string
  date?: string | Date
  description?: string
  disabled?: boolean
  businessId?: string
  business?: Business
  officeId?: string
  office?: Office
}

declare var $: any

@Component({
  selector: 'app-holidays',
  imports: [
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CapitalizePipe,
    HasPermissionDirective,
    PaginationComponent,
    RouterModule,
    NgSelectModule,
    SharedModule,
    NgxDaterangepickerBootstrapDirective
  ],
  templateUrl: './holidays.component.html',
  styleUrl: './holidays.component.scss'
})
export class HolidaysComponent implements OnInit, OnDestroy, AfterViewInit {
  private store = inject(Store)
  private holidaysService = inject(HolidayService)
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  toastr = inject(ToastrService)
  form!: FormGroup
  @ViewChild('addBusinessModal', { static: true }) addBusinessModal: ElementRef | undefined

  public holidayList: Holiday[] = []
  public totalCount = 0
  public currentPage = 1
  public pageLimit = 10
  public search = ''
  public searchYear: number = new Date().getFullYear() // current year
  public order = 'desc'
  businessList: UserBusinesses[] | undefined = []
  DeleteId!: string
  blockUnblockId!: string
  blockUnblockStatus!: string
  blockTilte!: string
  EditHoliday: Holiday | null = null
  user: User | null = null
  businessOwnerId = ''
  selectedBusiness!: string | null
  pageLastRecord = 0
  businessId = ''
  offices$!: Observable<Office[]>
  businessIdss!: string[]
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  selectedBusinessId = ''
  selectedOffice: Office | null = null
  private searchSubject = new Subject<string>()
  private destroy$ = new Subject<void>()
  selectedDateFilter = ''
  selectedYear!: number
  selectedMonth = new FormControl('', { nonNullable: true })
  // selectYear(year: number) {
  //   this.selectedYear = year
  //   this.getHolidaysList()
  // }
  // years: number[] = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i)
  @ViewChild('monthInput') monthInput!: ElementRef

  allYears: number[] = []
  years: number[] = []
  yearPageSize = 10
  yearCurrentPage = 1
  isOpen = false
  // selectYear(year: number) {
  //   this.searchYear = year
  //   this.getHolidaysList()
  // }
  constructor(private utilService: UtilsService) {
    this.offices$ = this.store.select(selectOffices)
  }

  // ngOnInit(): void {
  //   this.initializeform()
  //   this.store
  //     .select(selectUser)
  //     .pipe(take(1))
  //     .subscribe(user => {
  //       this.user = user
  //       // this.selectedBusiness = user?.business?.id ?? ''

  //       this.businessList = user?.businesses
  //       this.businesses$.subscribe(businesses => {
  //         if (businesses.length === 1) {
  //           this.form.get('businessId')?.setValue(businesses[0].id)
  //           this.selectedBusinessId = businesses[0].id
  //           this.selectedBusiness = businesses[0].id
  //           this.onBusinessChange(businesses[0].id)
  //           this.getHolidaysList()
  //         }
  //       })
  //       const businessIds = user?.businessIds // your array of business IDs
  //       if (businessIds && businessIds.length) {
  //         this.businessIdss = businessIds
  //         const paramString = `businessIds=${businessIds.join(',')}`
  //         this.store.dispatch(loadBusinesses({ params: paramString }))
  //       } else {
  //         this.loadAllBusinesses() // Load all businesses initially
  //         // this.loadAllBusinessOwners()
  //       }
  //       this.getHolidaysList()
  //       this.searchSubject.pipe(debounceTime(400), distinctUntilChanged()).subscribe(() => {
  //         this.currentPage = 1
  //         this.getHolidaysList()
  //       })
  //     })

  //   // Wait until the offices$ observable emits values
  //   // this.offices$.subscribe(offices => {
  //   //   // Initialize Select2 with office data
  //   //   $('#officeId').select2({
  //   //     placeholder: 'Select offices',
  //   //     allowClear: true
  //   //   })

  //   //   // Populate the options
  //   //   offices.forEach(office => {
  //   //     const option = $('<option>').val(office.id).text(office.officeName)
  //   //     $('#officeId').append(option)
  //   //   })

  //   //   // Add Select All and Unselect All buttons
  //   //   const selectAllOption = $('<option>').val('all').text('Select All')
  //   //   const unselectAllOption = $('<option>').val('none').text('Unselect All')
  //   //   $('#officeId').prepend(selectAllOption, unselectAllOption)
  //   // })

  //   // Handle Select All/Unselect All
  //   // $('#officeId').on('change', () => {
  //   //   const selectedValue = $('#officeId').val()
  //   //   if (selectedValue === 'all') {
  //   //     // Select all options
  //   //     this.offices$.subscribe(offices => {
  //   //       $('#officeId')
  //   //         .val(offices.map(office => office.id))
  //   //         .trigger('change')
  //   //     })
  //   //   } else if (selectedValue === 'none') {
  //   //     // Unselect all options
  //   //     $('#officeId').val([]).trigger('change')
  //   //   }
  //   // })
  // }

  // ngOnDestroy(): void {
  //   // Destroy Select2 when the component is destroyed to avoid memory leaks
  //   // $('#officeId').select2('destroy')
  // }

  ngOnInit(): void {
    this.initializeform()
    this.generateYears()
    this.updateYears()

    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        this.user = user
        this.businessList = user?.businesses
        const businessIds = user?.businessIds
        if (businessIds && businessIds.length) {
          this.businessIdss = businessIds
          const paramString = `businessIds=${businessIds.join(',')}`
          this.store.dispatch(loadBusinesses({ params: paramString }))
        } else {
          this.loadAllBusinesses()
        }
        this.businesses$
          .pipe(
            filter(businesses => businesses.length > 0),
            take(1),
            takeUntil(this.destroy$)
          )
          .subscribe(businesses => {
            if (businesses.length === 1) {
              this.form.get('businessId')?.setValue(businesses[0].id)
              this.selectedBusinessId = businesses[0].id
              this.selectedBusiness = businesses[0].id
              this.onBusinessChange(businesses[0].id)
            }
            this.getHolidaysList()
          })
        this.searchSubject
          .pipe(debounceTime(400), distinctUntilChanged(), takeUntil(this.destroy$))
          .subscribe(() => {
            this.currentPage = 1
            this.getHolidaysList()
          })

        this.getHolidaysList()
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  ngAfterViewInit() {
    $('#holidaySingleDate').daterangepicker({
      singleDatePicker: true,
      autoUpdateInput: false,
      showDropdowns: false,
      autoApply: false,
      maxDate: undefined,
      locale: { format: 'DD/MM/YYYY', cancelLabel: 'Clear' }
    })

    $('#holidaySingleDate').on('apply.daterangepicker', (ev: any, picker: any) => {
      const formatted = picker.startDate.format('DD/MM/YYYY')
      $('#holidaySingleDate').val(formatted)

      this.selectedDateFilter = picker.startDate.format('YYYY-MM-DD')
      this.currentPage = 1
      this.getHolidaysList()
    })

    $('#holidaySingleDate').on('cancel.daterangepicker', () => {
      this.clearDateFilter()
    })

    const today = new Date()

    flatpickr(this.monthInput.nativeElement, {
      dateFormat: 'Y',
      altInput: true,
      altFormat: 'Y',
      disableMobile: true,

      onReady: (selectedDates, dateStr, instance) => {
        // Force calendar to year view
        ;(instance as any).changeView('year')
      },

      onMonthChange: (_, __, instance) => {
        ;(instance as any).changeView('year')
      }
    })
  }

  clearDateFilter() {
    this.selectedDateFilter = ''
    $('#holidaySingleDate').val('')
    this.currentPage = 1
    this.getHolidaysList()
  }

  initializeform() {
    this.form = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(80)]], // Example validators
      date: ['', Validators.required], // Example validators
      description: ['', [Validators.maxLength(80)]], // Example validators
      disabled: [false],
      businessId: ['', Validators.required],
      offices: ['', Validators.required]
    })
  }

  //pagination
  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.currentPage = newPage
      this.getHolidaysList() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  //modal open
  openBusiness(content: unknown) {
    this.EditHoliday = null
    this.modalService.open(content, { scrollable: false, centered: true, size: 'md' })
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)

    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  getHolidaysList() {
    //let skip = this.currentPage * this.pageLimit - this.pageLimit
    //const search = this.search
    //  ? {
    //      $or: { title: { $like: `%${this.search}%` } },
    //      $and: { businessId: { $like: `%${this.selectedBusinessSort}%` } }
    //    }
    //  : {}

    const officeId = this.selectedOffice?.id || ''
    // const fromDate = this.selectedDateFilter || ''
    // const toDate = this.selectedDateFilter || ''
    const year = this.searchYear || new Date().getFullYear()

    const fromDate = `${year}-01-01`
    const toDate = `${year}-12-31`

    this.holidaysService
      .list(
        this.selectedBusiness!,
        this.search!,
        this.currentPage,
        this.pageLimit,
        this.searchYear,
        officeId,
        fromDate,
        toDate
      )
      .subscribe({
        next: response => {
          // const today = new Date()
          this.holidayList = response.holidays
          // .filter((h: Holiday) => {
          //   const holidayDate = new Date(h.date as string | Date)
          //   return holidayDate >= today
          // })
          this.totalCount = response.totalCount
          this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
        },
        error: (error: { message: string }) => {
          this.toastr.error('Error: ' + error.message)
        }
      })
  }

  onOfficeChange(office: Office | null) {
    this.selectedOffice = office
    this.currentPage = 1
    this.getHolidaysList()
  }

  onFilterBusinessChange(business: any) {
    // ✅ handle both cases (string or object)
    this.selectedBusiness = typeof business === 'string' ? business : business?.id || null

    this.selectedOffice = null
    this.currentPage = 1

    if (this.selectedBusiness) {
      const params = `businessId=${encodeURIComponent(this.selectedBusiness)}`
      this.store.dispatch(loadOffices({ params }))
    } else {
      this.store.dispatch(resetOfficeState())
    }

    this.getHolidaysList()
  }

  openBlockUnblock(content: unknown, id: string, title: string, status: string) {
    this.blockUnblockId = id
    this.blockTilte = title
    if (status === 'Active') {
      this.blockUnblockStatus = 'Inactive'
    } else if (status === 'Inactive') {
      this.blockUnblockStatus = 'Active'
    }

    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmBlockUnblock() {
    if (this.blockUnblockId) {
      // Prepare the request body
      const requestBody = {
        disabled: this.blockUnblockStatus === 'Active' ? false : true,
        id: this.blockUnblockId,
        title: this.blockTilte
      }

      this.holidaysService
        .update(this.blockUnblockId, requestBody)
        .subscribe((res: { id: unknown }) => {
          if (res.id) this.toastr.success('Success!')
        })
      this.getHolidaysList()
      this.onClose()
    }
  }

  openDelete(content: unknown, id: string) {
    this.DeleteId = id
    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  confirmDelete() {
    if (this.DeleteId) {
      this.holidaysService.delete(this.DeleteId).subscribe(() => {
        this.toastr.success('Deleted successfully !')
        // this.toastr.success(`${}`)
      })
      this.getHolidaysList()
      this.onClose()
    }
  }

  openEditHoliday(content: unknown, holiday: Holiday) {
    this.EditHoliday = holiday
    this.form.get('title')?.setValue(holiday.title)
    this.form.get('date')?.setValue(holiday.date)
    this.form.get('description')?.setValue(holiday.description)
    this.form.get('businessId')?.setValue(holiday.businessId)
    if (holiday.businessId) {
      this.onBusinessChange(holiday.businessId)
    }

    this.form.get('offices')?.setValue([holiday.officeId])
    this.form.get('disabled')?.setValue(holiday.disabled)
    this.modalService.open(content, { scrollable: false, centered: true, size: 'md' })
  }

  onSubmit() {
    if (this.form.valid) {
      const formData = {
        ...this.form.value // Spread the form values
      }
      if (!this.EditHoliday) {
        this.holidaysService.create(formData).subscribe({
          next: () => {
            // this.toastr.success('Holiday Created successfully!')
            this.toastr.success(`Holiday,  "${formData.title}", is Createed Sucesfully`)
            this.getHolidaysList()
            this.onClose()
          },
          // error: (error: { message: string }) => {
          //   this.toastr.error('Error: ' + error.message)
          // }
          error: (error: any) => {
            const message =
              error?.error?.message ||
              'A holiday with the same name and date already exists for this business entity.'

            this.toastr.error(message)
          }
        })
      } else if (this.EditHoliday) {
        this.holidaysService.update(this.EditHoliday.id, formData).subscribe({
          next: () => {
            this.toastr.success('Holiday updated successfully!')

            this.getHolidaysList()
            this.onClose()
            this.EditHoliday = null
          },
          // error: (error: { message: string }) => {
          //   this.toastr.error('Error: ' + error.message)
          // }
          error: (err: any) => {
            this.toastr.error('Error: ' + err?.error?.message)
          }
        })
      }
    } else {
      // Mark all controls as touched to trigger validation error display
      this.form.markAllAsTouched()
    }
    // this.onClose()
  }

  getBusinessName(businessId: string | undefined): string | undefined {
    if (!businessId) return ''
    return this.businessList?.find(b => b.id === businessId)?.businessName
  }

  filterByBusiness(event: Event): void {
    const target = event.target as HTMLSelectElement // Cast to HTMLSelectElement

    if (target.value !== '') this.selectedBusiness = target.value
    this.getHolidaysList()
  }

  //hasPermission(permission: string): boolean {
  //  return this.authService.hasPermission(permission)
  //}

  onPageLimitChange() {
    this.currentPage = 1
    this.getHolidaysList()
  }

  onClose() {
    this.initializeform()
    this.modalService.dismissAll()
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  onBusinessChange(businessId: string) {
    this.selectedOffice = null
    this.form.get('offices')?.setValue('')
    if (businessId) {
      // Call a method to fetch data based on the selected owner
      const params = `businessId=${encodeURIComponent(businessId)}`

      this.store.dispatch(loadOffices({ params })) // Dispatch action with filter
    } else {
      // const params = ''
      // this.store.dispatch(
      //   loadDepartments({ params, page: this.currentPage, limit: this.pageLimit })
      // )
      // Dispatch action with filter
      // Handle the case where no owner is selected

      this.store.dispatch(resetOfficeState())
      // this.store.dispatch(resetDepartmentState())
      // this.store.dispatch(resetDesignationState())
    }
  }

  loadAllBusinesses() {
    const params: any = {}
    if (this.businessIdss?.length) {
      params.businessIds = this.businessIdss.join(',')
    }
    params.disabled = false
    this.store.dispatch(
      loadBusinesses({
        params: new URLSearchParams(params).toString()
      })
    )
  }

  isHolidayPassed(holiday: Holiday): boolean {
    if (!holiday?.date) {
      return false // or true, depending on how you want to treat missing dates
    }
    const today = new Date()
    const holidayDate = new Date(holiday.date as string | Date) // force safe type
    return holidayDate < today
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilService.getDashboardRoute()
  }

  customSearchFnOffice = (term: string, item: any) => {
    const fullName = `${item.officeName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  customSearchFnBusiness = (term: string, item: any) => {
    const fullName = `${item.businessName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  isAdmin(): boolean {
    // return this.user?.role === 'Admin'
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  }

  isBusinessOwner(): boolean {
    // return this.user?.role === 'Admin'
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Business Owner') ?? false
  }

  onSearchChange(value: string) {
    this.searchSubject.next(value)
  }

  // onDateSelected(event: any) {
  //   const date = event?.startDate?._d || event?._d || event
  //   if (date) {
  //     this.selectedYear = new Date(date).getFullYear()
  //   }
  // }

  // onYearInput(event: any) {
  //   let value = event.target.value

  //   value = value.replace(/[^0-9]/g, '') // strict digits only

  //   if (value.length > 4) {
  //     value = value.slice(0, 4)
  //   }

  //   this.searchYear = value ? Number(value) : new Date().getFullYear()

  //   this.getHolidaysList()
  // }

  generateYears() {
    const current = new Date().getFullYear()
    const start = current + 1
    const end = 1990

    this.allYears = Array.from({ length: start - end + 1 }, (_, i) => start - i)
  }

  updateYears() {
    const start = (this.yearCurrentPage - 1) * this.yearPageSize
    const end = start + this.yearPageSize

    this.years = this.allYears.slice(start, end)
  }
  toggleDropdown() {
    this.isOpen = !this.isOpen
  }

  selectYear(y: number) {
    this.searchYear = y
    this.isOpen = false
    this.getHolidaysList()
  }

  nextYearPage() {
    if (this.yearCurrentPage * this.yearPageSize < this.allYears.length) {
      this.yearCurrentPage++
      this.updateYears()
    }
  }

  prevYearPage() {
    if (this.yearCurrentPage > 1) {
      this.yearCurrentPage--
      this.updateYears()
    }
  }
}
